export default __webpack_public_path__ + "static/media/edit_stato_occupazionale.7c007514.less";